module.exports = __webpack_public_path__ + "static/img/s1en.2fa5749.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/samSet/s1en.png
// module id = WXGY
// module chunks = 0